/* /mtg-odds — opening hands from a real list (London mulligan; in Commander the first mulligan is free and
 * the commander stays in the command zone), the exact land odds for that deck, and the draw-odds
 * calculator with a by-turn table. Tab + calculator state live in the URL hash (#calc?N=99&K=38&n=7&k=2).
 */
import "../lib/site.js";
import "../tools/panel.js";

(function () {
  "use strict";

  var KD = window.KD, T = KD.tools, esc = KD.esc;
  var out = KD.$("[data-out]"), result = KD.$("[data-result]"), tbody = KD.$("[data-byturn] tbody");
  if (!out || !result) return;
  var emptyHTML = out.innerHTML;
  var pool = [], lands = 0, isCmd = false, deckLabel = "";
  var st = { mulls: 0, seven: [], bottom: {}, extra: [], next: 7, deck: [] };
  var freeMull = true;

  // ---------------------------------------------------------------- tabs
  var tabs = KD.$$("[data-tab]"), panels = KD.$$("[data-panel]");
  function showTab(name, push) {
    tabs.forEach(function (t) { t.setAttribute("aria-selected", String(t.getAttribute("data-tab") === name)); });
    panels.forEach(function (p) { p.hidden = p.getAttribute("data-panel") !== name; });
    if (push) try { history.replaceState(null, "", name === "calc" ? "#calc" : location.pathname + location.search); } catch (e) { /* ignore */ }
    if (name === "calc") calc();
  }
  tabs.forEach(function (t) { t.addEventListener("click", function () { showTab(t.getAttribute("data-tab"), true); KD.ga("odds_tab", { tab: t.getAttribute("data-tab") }); }); });

  // ---------------------------------------------------------------- deck → pool
  var panel = KD.toolPanel({ key: "kraken_pending_odds", example: KD.EXAMPLE_CMD, run: load, clear: function () { out.innerHTML = emptyHTML; pool = []; } });

  function imgOf(card) {
    if (card.image_uris) return card.image_uris.normal || card.image_uris.small || "";
    var f = (card.card_faces || [])[0];
    return f && f.image_uris ? f.image_uris.normal || "" : "";
  }
  async function load(text, reason) {
    var parsed = T.parseDecklist(text);
    if (!parsed.rows.length) { panel.status("No card lines found. Paste one card per line, like “1 Sol Ring”."); return; }
    panel.status("Looking up " + parsed.rows.length + " cards on Scryfall…", true);
    var res;
    try { res = await T.resolveCards(parsed.rows, function (d, t) { panel.status("Looking up cards… " + d + " of " + t, true); }); }
    catch (e) { panel.status("Scryfall didn't answer. Try again in a moment."); return; }
    panel.status("");
    if (!res.matched.length) {
      out.innerHTML = '<div class="tool__empty"><svg class="i" aria-hidden="true"><use href="#i-alert"/></svg><h2>No cards matched</h2><p>Check the spelling, one card per line.</p></div>' + KD.unmatchedHTML(res.unmatched, "dealt");
      return;
    }
    var total = res.matched.reduce(function (s, x) { return s + (x.row.quantity || 1); }, 0);
    var cmds = res.matched.filter(function (x) { return x.row.commander; });
    isCmd = cmds.length > 0 || total >= 90;
    freeMull = isCmd;
    pool = []; lands = 0;
    res.matched.forEach(function (x) {
      if (x.row.commander) return; // command zone, not the library
      var land = T.isLand(x.card), cmc = typeof x.card.cmc === "number" ? x.card.cmc : 0;
      for (var q = 0; q < (x.row.quantity || 1); q++) pool.push({ name: x.card.name, land: land, cmc: cmc, img: imgOf(x.card) });
      if (land) lands += x.row.quantity || 1;
    });
    deckLabel = cmds.length ? cmds.map(function (x) { return x.card.name; }).join(" + ") : (isCmd ? "Commander deck" : total + "-card deck");
    if (pool.length < 7) { out.innerHTML = '<div class="tool__empty"><svg class="i" aria-hidden="true"><use href="#i-alert"/></svg><h2>Not enough cards</h2><p>A hand needs at least 7 cards in the library.</p></div>'; return; }
    fillCalc(pool.length, lands);
    deal(0, true);
    paintUnmatched(res.unmatched);
    KD.ga("odds_load", { reason: reason, cards: pool.length, commander: isCmd });
    if (reason !== "handoff" || KD.mobile()) out.scrollIntoView({ behavior: KD.reduce ? "auto" : "smooth", block: "start" });
  }
  var unmatchedHTML = "";
  function paintUnmatched(u) { unmatchedHTML = KD.unmatchedHTML(u, "dealt"); var box = KD.$("[data-unmatched]", out); if (box) box.innerHTML = unmatchedHTML; }

  // ---------------------------------------------------------------- dealing
  function shuffle(a) { a = a.slice(); for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t; } return a; }
  function deal(mulls, fresh) {
    st.mulls = mulls;
    st.deck = shuffle(pool);
    st.seven = st.deck.slice(0, 7);
    st.next = 7;
    st.extra = [];
    st.bottom = T.pickBottom(st.seven, T.bottomCount(mulls, freeMull && isCmd));
    paint(fresh);
  }
  function drawOne() {
    if (st.next >= st.deck.length) { KD.toast("Your library is empty.", "info"); return; }
    st.extra.push(st.deck[st.next++]);
    paint(false);
  }

  function cardHTML(c, cls, tag) {
    var img = KD.safeUrl(c.img);
    return '<div class="hand__card ' + (cls || "") + '" title="' + esc(c.name) + '">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(c.name) + '" loading="lazy">' : '<span class="noimg">' + esc(c.name) + "</span>") + (tag ? '<span class="hand__tag">' + tag + "</span>" : "") + "</div>";
  }
  function paint(fresh) {
    var bottomN = T.bottomCount(st.mulls, freeMull && isCmd), keep = 7 - bottomN;
    var kept = st.seven.filter(function (c, i) { return !st.bottom[i]; }).concat(st.extra);
    var kl = kept.filter(function (c) { return c.land; }).length, ks = kept.length - kl;
    var mv = kept.filter(function (c) { return !c.land; }).reduce(function (s, c) { return s + c.cmc; }, 0);
    var openLands = st.seven.filter(function (c, i) { return !st.bottom[i] && c.land; }).length;
    var good = openLands >= 2 && openLands <= 5;
    var verdict = st.extra.length ? "" : openLands < 2 ? "Few lands: usually a mulligan." : openLands > 5 ? "Land-heavy: a flood risk." : "A keepable land count.";
    var canMull = st.mulls < T.MAX_MULLIGANS;
    var dist = T.distribution(pool.length, lands, 7), maxP = Math.max.apply(null, dist);
    var keepable = dist.slice(2, 6).reduce(function (s, x) { return s + x; }, 0);
    out.innerHTML =
      '<div class="ohand' + (fresh ? " is-fresh" : "") + '"><div class="ohand__bar"><div><p class="depth-tag">' + esc(deckLabel) + "</p><h2>" + (st.mulls ? "Mulligan " + st.mulls + ": keep " + keep : "Opening hand") + "</h2></div>" +
        '<span class="badge ' + (good ? "badge--glow" : "badge--lure") + '">' + openLands + (openLands === 1 ? " land" : " lands") + "</span></div>" +
        '<div class="ohand__cards">' + st.seven.map(function (c, i) { return cardHTML(c, st.bottom[i] ? "is-bottom" : "", st.bottom[i] ? "Bottom" : ""); }).join("") +
          st.extra.map(function (c, i) { return cardHTML(c, "is-drawn", "Turn " + (i + 2)); }).join("") + "</div>" +
        '<p class="ohand__sum"><b>' + kept.length + " cards:</b> " + kl + (kl === 1 ? " land" : " lands") + ", " + ks + (ks === 1 ? " spell" : " spells") + (ks ? ", average mana value " + (mv / ks).toFixed(2) : "") + ". " + verdict + "</p>" +
        '<div class="ohand__go"><button class="btn btn--lure btn--sm" type="button" data-new><svg class="i" aria-hidden="true"><use href="#i-refresh"/></svg>New hand</button>' +
          '<button class="btn btn--ghost btn--sm" type="button" data-mull' + (canMull ? "" : " disabled") + '><svg class="i" aria-hidden="true"><use href="#i-replay"/></svg>Mulligan' + (canMull ? " to " + (7 - T.bottomCount(st.mulls + 1, freeMull && isCmd)) : "") + "</button>" +
          '<button class="btn btn--ghost btn--sm" type="button" data-draw><svg class="i" aria-hidden="true"><use href="#i-plus"/></svg>Draw for turn ' + (st.extra.length + 2) + "</button>" +
          (isCmd ? '<label class="check"><input type="checkbox" data-free' + (freeMull ? " checked" : "") + "><span>First mulligan free</span></label>" : "") + "</div></div>" +
      '<section class="panel panel--pad odist"><div class="row row--between"><h3 class="label">Lands in your opening seven</h3><span class="hint">' + pool.length + " cards · " + lands + " lands" + (isCmd ? " · commander in the command zone" : "") + "</span></div>" +
        '<div class="odist__bars">' + dist.map(function (p, i) {
          return '<div class="' + (i >= 2 && i <= 5 ? "is-keep" : "") + '"><b>' + (p >= 0.0005 ? (p * 100).toFixed(p < 0.1 ? 1 : 0) + "%" : "") + '</b><i style="height:' + Math.max(p ? 3 : 0, Math.round(p / maxP * 100)) + '%"></i><em>' + i + "</em></div>";
        }).join("") + "</div>" +
        '<p class="odist__sum"><b>' + (keepable * 100).toFixed(1) + "%</b> of opening hands have 2 to 5 lands.</p></section>" +
      '<div data-unmatched>' + unmatchedHTML + "</div>";
  }
  out.addEventListener("click", function (e) {
    if (!pool.length) return;
    if (e.target.closest("[data-new]")) { deal(0); KD.ga("odds_new_hand"); }
    else if (e.target.closest("[data-mull]")) { if (st.mulls < T.MAX_MULLIGANS) deal(st.mulls + 1); KD.ga("odds_mulligan", { n: st.mulls }); }
    else if (e.target.closest("[data-draw]")) drawOne();
  });
  out.addEventListener("change", function (e) {
    var f = e.target.closest("[data-free]");
    if (!f) return;
    freeMull = f.checked;
    st.bottom = T.pickBottom(st.seven, T.bottomCount(st.mulls, freeMull && isCmd));
    paint(false);
  });

  // ---------------------------------------------------------------- calculator
  var inputs = {};
  KD.$$("[data-n]").forEach(function (i) { inputs[i.getAttribute("data-n")] = i; });
  function num(k) { return parseInt(inputs[k].value, 10); }
  function fillCalc(N, K) {
    inputs.N.value = N; inputs.K.value = K; inputs.n.value = 7;
    var note = KD.$("[data-calc-from]");
    if (note) note.innerHTML = "Filled in from your deck: <b>" + N + " cards, " + K + " lands</b>. Change “Copies in the deck” to any group of cards you care about.";
    calc();
  }
  function calc() {
    var N = num("N"), K = num("K"), n = num("n"), k = num("k");
    var err = T.validateHyper(N, K, n, k);
    if (err) { result.innerHTML = '<p class="oresult__err"><svg class="i" aria-hidden="true"><use href="#i-alert"/></svg>' + esc(err) + "</p>"; tbody.innerHTML = ""; return; }
    var p = T.hyperAtLeast(N, K, n, k);
    var near = [Math.max(0, k - 1), Math.min(n, k + 1)].filter(function (x) { return x !== k; });
    result.innerHTML = '<p class="oresult__pct">' + (p * 100).toFixed(p > 0.999 || p < 0.001 ? 2 : 1) + "%</p>" +
      '<p class="oresult__txt">chance of at least <b>' + k + "</b> of your <b>" + K + "</b> copies in <b>" + n + "</b> cards from a <b>" + N + "</b>-card deck</p>" +
      '<div class="oresult__near">' + near.map(function (x) { return "<span>At least " + x + ": <b>" + (T.hyperAtLeast(N, K, n, x) * 100).toFixed(1) + "%</b></span>"; }).join("") + "</div>";
    var rows = T.byTurn(N, K, k, 8, Math.min(N, 7));
    tbody.innerHTML = rows.map(function (r) { return "<tr><td>" + r.turn + "</td><td>" + (r.play * 100).toFixed(1) + "%</td><td>" + (r.draw * 100).toFixed(1) + "%</td></tr>"; }).join("");
    var note = KD.$("[data-byturn-note]");
    if (note) note.textContent = "at least " + k + " by each turn, from an opening seven";
    try { if (!KD.$('[data-panel="calc"]').hidden) history.replaceState(null, "", "#calc?N=" + N + "&K=" + K + "&n=" + n + "&k=" + k); } catch (e) { /* ignore */ }
  }
  var ct = 0;
  Object.keys(inputs).forEach(function (k) { inputs[k].addEventListener("input", function () { clearTimeout(ct); ct = setTimeout(calc, 120); }); });
  KD.$$("[data-preset]").forEach(function (b) {
    b.addEventListener("click", function () { inputs.k.value = b.getAttribute("data-preset"); inputs.n.value = 7; calc(); KD.ga("odds_preset", { k: b.getAttribute("data-preset") }); });
  });

  // #calc?N=..&K=..&n=..&k=.. opens the calculator with those numbers
  var h = location.hash.match(/^#calc(?:\?(.*))?$/);
  if (h) {
    new URLSearchParams(h[1] || "").forEach(function (v, k) { if (inputs[k] && /^\d{1,4}$/.test(v)) inputs[k].value = v; });
    showTab("calc", false);
  } else calc();
})();
